import notebookRequest from '@apis/notebook'
import {Button, Flex, Input, Text} from '@chakra-ui/react'
import {updateIsOpenModalCreateFolder} from '@redux/notebook/notebookSlice'
import {Modal, message} from 'antd'
import {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

const FormCreateFolder = ({
  getFolders,
  setNewFolder,
}: {
  getFolders: any
  setNewFolder: any
}) => {
  const {isOpenModalCreateFolder} = useSelector((state: any) => state.notebook)
  const [inputText, setInputText] = useState<any>('')
  const [messageApi, contextHolder] = message.useMessage()
  const [isLoading, setIsLoading] = useState<any>(false)

  const dispatch = useDispatch()

  const handleChange = (e: any) => {
    if (e.target.value.length > 50) {
      return
    }

    setInputText(e.target.value)
  }

  const handleKeyDown = (e: any) => {
    if ((e.code === 'Enter' || e.key === 'Enter') && inputText) {
      handleCreateFolder()
    }
  }

  const handleCreateFolder = async () => {
    setIsLoading(true)
    let trimmedStr = inputText.replace(/^\s+|\s+$/g, '')
    const params = {name: trimmedStr}
    const res = await notebookRequest.createFolder(params)
    if (res?.status === 200) {
      dispatch(updateIsOpenModalCreateFolder(false))
      setInputText('')
      messageApi.success('Thành công!')
      setNewFolder(trimmedStr)
    }
    setIsLoading(false)
  }

  const handleCancel = () => {
    dispatch(updateIsOpenModalCreateFolder(false))
    setInputText('')
  }

  return (
    <>
      {contextHolder}
      <Modal
        title={
          <Text fontSize={'16px'} fontWeight={600}>
            Tạo thư mục mới
          </Text>
        }
        destroyOnClose={true}
        zIndex={1501}
        open={isOpenModalCreateFolder}
        footer={null}
        styles={{
          content: {borderRadius: '24px', padding: '28px'},
        }}
        onCancel={handleCancel}>
        <Flex gap={'16px'} alignItems={'center'} mt={'16px'}>
          <Input
            placeholder="Nhập tên mục"
            value={inputText}
            onChange={handleChange}
            onKeyDown={handleKeyDown}></Input>
          <Button
            isDisabled={Boolean(!inputText) || isLoading}
            fontSize={'16px'}
            fontWeight={700}
            color={'white'}
            borderRadius={'12px'}
            bg={'#1890FF'}
            _hover={{
              bg: '#49a7ff',
            }}
            onClick={handleCreateFolder}>
            {!isLoading ? 'Tạo' : 'Đang tạo'}
          </Button>
        </Flex>
      </Modal>
    </>
  )
}
export default FormCreateFolder
